var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('input',{staticClass:"form-control",attrs:{"type":"text","disabled":_vm.disabled},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.updateValue($event.target.value)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }